import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

const intlData = defineMessages({
  unread: {
    id: 'invite.all_bookings.unread',
    defaultMessage: 'All ({count} unread)'
  },
  accepted: {
    id: 'invite.all_bookings.accepted',
    defaultMessage: 'Accepted Bookings'
  },
  pastBookings: {
    id: 'invite.all_bookings.past_bookings',
    defaultMessage: 'Past Bookings'
  },
  upcomingBookings: {
    id: 'invite.all_bookings.upcoming_bookings',
    defaultMessage: 'upcoming bookings'
  },
  priority: {
    id: 'invite.all_bookings.priority',
    defaultMessage: 'Priority'
  },
  everythingElse: {
    id: 'invite.all_bookings.everything_else',
    defaultMessage: 'Everything else'
  }
});

export const PastBookings = {
  tabs: [{
    label: <FormattedMessage {...intlData.pastBookings} />,
    name: 'past'
  }]
};

export const RequestedBookings = {
  tabs: [{
    label: <FormattedMessage {...intlData.priority} />,
    name: 'requested'
  }],
  placeholder: {
    icon: 'icon-calendar-booking',
    content: 'booking requests'
  }
};

export const AllOtherBookings = {
  tabs: [{
    label: <FormattedMessage {...intlData.everythingElse} />,
    name: 'not_requested'
  }],
  placeholder: {
    icon: 'icon-messages',
    content: 'messages'
  }
};

export const AllBookings = (unreadMsgCount) => {
  return {
    tabs: [
      {
        label: <FormattedMessage {...intlData.unread} values={{ count: unreadMsgCount || 0 }} />,
        link: 'inbox',
        name: 'inbox'
      },
      {
        label: <FormattedMessage {...intlData.accepted} />,
        link: 'bookings',
        name: 'bookings'
      }
    ],
    placeholder: {
      icon: 'icon-messages',
      content: 'messages'
    }
  };
};

export const AcceptedBookings = (unreadMsgCount) => {
  return {
    tabs: [
      {
        label: <FormattedMessage {...intlData.unread} values={{ count: unreadMsgCount || 0 }} />,
        link: 'inbox',
        name: 'inbox'
      },
      {
        label: <FormattedMessage {...intlData.accepted} />,
        link: 'bookings',
        name: 'bookings'
      }
    ],
    placeholder: {
      icon: 'icon-calendar-booking',
      content: <FormattedMessage {...intlData.upcomingBookings} />,
    }
  };
};
